<script setup>

import { ref, reactive, watch, computed, onMounted } from 'vue';
import { format$ } from '@/libraries/HelperFunctions';

import { AppointmentCodes, CodePrefixes } from '@/billing/AppointmentCodes';

const state = reactive({
    selectedCode: null,
    autoSelect: false,
    appointmentCodes: AppointmentCodes,
})

const props = defineProps(['newApt', 'appointments', 'patient']);
const emits = defineEmits(['onCodeSelect', 'onValidate']);

// on initialize
onMounted(() => {
    // no auto select for editing appt
    if (props.newApt.uniqueAppointmentId) {
        state.autoSelect = true;
        props.newApt.codes.forEach(aptCd => {
            state.selectedCode = state.appointmentCodes.filter(cd => cd.code == aptCd.substr(1))[0];
        });
        console.log('emitting??')
        emitSelectedCode();
    }
    validateCodes();
})

const sortedCodes = computed(() => {
    return state.appointmentCodes.sort((a, b) => {
        if (a.applicable && !b.applicable) {
            return -1;
        } else if (!a.applicable && b.applicable) {
            return 1;
        } else {
            if (a.price > b.price) {
                return -1;
            } else if (a.price < b.price) {
                return 1;
            }
            else return 0;
        }
    });
})

watch(() => props.newApt, (val) => {
    validateCodes();
}, { deep: true })


function highestPayingCode() {
    const applicableCodes = state.appointmentCodes.filter(cd => cd.applicable);
    let selectedCode = applicableCodes[0];
    applicableCodes.forEach(cd => {
        if (cd.price > selectedCode.price) selectedCode = cd;
    });
    return selectedCode;
}

function codeNum(codeSuffix) {
    return CodePrefixes[props.newApt.aptType] + codeSuffix;
}

/**
 * Selects a new code or toggles the value if same code
 * @param {Code} code 
 */
function selectCode(code) {
    if (state.selectedCode == code && !state.autoSelect) { // if they click same code, remove it
        state.selectedCode = null;
        emits('onCodeSelect', []);
        return;
    }
    state.selectedCode = code;
    emitSelectedCode();
}

function emitSelectedCode() {
    let code = state.selectedCode;
    if (code) {
        emits('onCodeSelect', [{
            price: code.price,
            name: code.name,
            code: codeNum(code.code),
        }]);
    } else {
        emits('onCodeSelect', []);
    }
}

function validateCodes() {
    let requiredQuestions = [];
    state.appointmentCodes.forEach(c => {
        const model = {
            self: c,
            newApt: props.newApt,
            appointments: props.appointments,
            patient: props.patient,
        }
        let cQuestions = c.validate(model) || []; // if c.validate(model), equal that, else make it [] since it probably should be that anyways
        requiredQuestions.push(...cQuestions);
    })
    emits("onValidate", requiredQuestions)
    console.log('questions', requiredQuestions)
    state.showQuestions = requiredQuestions;
    // set selectedCode if autoselect mode
    if (state.autoSelect) selectCode(highestPayingCode());
}

function onClickCode(code) {
    if (state.autoSelect) {
        if (confirm('Do you want to turn off Verus Recommended?')) state.autoSelect = false;
    }
    if (!state.autoSelect) selectCode(code);
}

</script>
<template>
    <div style="margin: 0 0 10px 0; text-align: center">
        <span class="label"><i class="fa fa-wand-magic-sparkles"></i> Verus Recommended</span> <input
            @change="validateCodes" type="checkbox" v-model="state.autoSelect">
    </div>
    <div v-for="code in sortedCodes" @click="onClickCode(code)"
        :class="{ selected: state.selectedCode == code, applicable: code.applicable }" class="code-block">
        <div class="info">
            <div class="code">{{ codeNum(code.code) }}</div>
            <div class="name">{{ code.name }}</div>
            <div class="price">{{ format$(code.price) }}</div>
        </div>
        <div class="reason" v-if="code.reasonNotApplicable"><i class="far fa-triangle-exclamation"></i> {{
            code.reasonNotApplicable }}</div>
    </div>
</template>
<style lang="scss">
span.label {
    display: inline-block;
    vertical-align: top;
    padding-top: 4px;
    color: #673ab7;
    text-transform: uppercase;
}
</style>